

export default class QuestionUtils {
  
  static SortQuestionByPart = function(a, b) {
    return a.part() - b.part();
  }
  
  
}